// extracted by mini-css-extract-plugin
export default {"asi":"asi__bN2WV"};